module.exports = __webpack_public_path__ + "img/profile-icon.8c6617cc.svg";